import { md5 } from "src/common/utils/md5.js";

// Gravatar hashes the lowercased, trimmed email — matching their spec is
// required for the hash to resolve to the right (or any) profile.
const gravatarHash = (email: string) => md5(email.trim().toLowerCase());

export const getGravatarUrl = (email: string) => {
	return `https://www.gravatar.com/avatar/${gravatarHash(email)}?d=identicon`;
};

export const getGravatarProfileUrl = (email: string) => {
	return `https://gravatar.com/${gravatarHash(email)}`;
};
